export const translations = {
  pagerInfo: {
    id: "pagerInfo",
    defaultMessage: "{0} - {1}, of {2} records.",
  },
  showInfo: {
    id: "show",
    defaultMessage: "Show",
  },
};

export const defaultPageSize = 5;
export const defaultPageSizeOptions = ["5", "10", "20", "30", "40", "50"];
